export default "__VITE_ASSET__872b4a2f__"